import React, { useState, useEffect, useCallback } from "react";
import SchoolDatePicker from "../../components/SchoolDatePicker/SchoolDatePicker";
import {
    Button, FormControl, MenuItem, TableRow, Table, TableHead,
    TableBody, TableCell, TableContainer, Paper, Card, Box,
    Select, TextField, Typography, IconButton, InputAdornment,
    Tooltip, Avatar,
} from "@material-ui/core";
import ExportExcel from "../../Excelexport";
import AttendenceService from "./Locality/Service/attendenceService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import StudentService from "./Locality/Service/studentService";
import TablePagination from '@material-ui/core/TablePagination';
import { makeStyles } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles((theme) => ({
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        fontWeight: 700,
        fontSize: '1.9rem',
        color: '#0f2d4d',
        lineHeight: 1.2,
    },
    pageSubtitle: {
        color: '#6b7280',
        fontSize: '0.9rem',
        marginTop: 2,
    },
    noteBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 12,
        backgroundColor: '#eef4ff',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    noteIconWrap: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: '#1769d6',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    filtersCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    filtersRow: {
        display: 'flex',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        width: '100%',
    },
    filtersChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: 40,
        boxSizing: 'border-box',
        padding: '0 12px',
        borderRadius: 8,
        border: '1px solid #d9dee7',
        backgroundColor: '#f7f9fc',
        cursor: 'pointer',
        fontWeight: 600,
        color: '#0f2d4d',
        userSelect: 'none',
        flexShrink: 0,
    },
    countBadge: {
        backgroundColor: '#1769d6',
        color: '#fff',
        borderRadius: 10,
        fontSize: '0.72rem',
        fontWeight: 700,
        minWidth: 18,
        height: 18,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 5px',
    },
    fieldLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
        minHeight: 18,
        lineHeight: '18px',
    },
    filterFieldWrap: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 0',
        minWidth: 150,
    },
    filterActionsWrap: {
        display: 'flex',
        flexDirection: 'column',
        flex: '0 0 auto',
        justifyContent: 'flex-end',
    },
    primaryBtn: {
        backgroundColor: '#1769d6',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 18px',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    resetBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
        border: '1px solid #e6eaf0',
        height: 40,
        minWidth: 88,
        padding: '0 16px',
    },
    tableCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        overflow: 'hidden',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid #eef1f5',
    },
    iconBtnOutlined: {
        border: '1px solid #e6eaf0',
        borderRadius: 8,
        padding: 7,
    },
    headCell: {
        backgroundColor: '#f4f6fa',
        color: '#46566b',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #e6eaf0',
        whiteSpace: 'nowrap',
    },
    studentAvatar: {
        width: 28,
        height: 28,
        fontSize: '0.72rem',
        fontWeight: 700,
        backgroundColor: '#1769d6',
        color: '#fff',
    },
    statPill: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 12,
        fontWeight: 600,
        fontSize: '0.82rem',
    },
}));

export default function Reports() {
    const classes = useStyles();
    const [result, setResult] = useState([]);
    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(1000);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [studentId, setStudentId] = useState("");
    const [classId, setClassId] = useState("");
    const [sectionId, setSectionId] = useState("");
    const [sectionList, setSectionList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [getReport, setGetReport] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [noteOpen, setNoteOpen] = useState(true);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};

    const excelExport = (res) => {
        const exportResult = res.map((response) => ({
            "Student Name": response.studentName,
            "Count": response.count,
            "Date": response.present,
            "Absent": response.absent,
            "Late Coming": response.lateComing || 0,
            "Early Going": response.earlyGoing || 0,
        }));
        setResult(exportResult);
    };

    const fetchReport = useCallback(() => {
        if (!classId) return;

        const report = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate1 = startDate1 ? startDate1 : null;
        const newendDate1 = endDate1 ? endDate1 : null;

        const keys = {
            "schooleId": report.schoolId,
            "studentId": studentId,
            "startDate1": newstartDate1,
            "endDate1": newendDate1,
            "classId": classId,
            "sectionId": sectionId || userDetails.sectionId || undefined,
        };
        AttendenceService.getStuAttReport(keys).then((res) => {
            excelExport(res);
            setGetReport(Array.isArray(res) ? res : []);
            setpg(0);
        }).catch(() => {});
    }, [classId, sectionId, studentId, startDate1, endDate1, userDetails.sectionId]);

    useEffect(() => {
        fetchReport();
    }, [fetchReport]);

    useEffect(() => {
        getAddClassList();
        return () => {
            setStudentList([]);
            setGetReport([]);
        };
    }, []);

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    };

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    };

    const activeFilterCount =
        (classId ? 1 : 0) +
        (sectionId ? 1 : 0) +
        (studentId ? 1 : 0) +
        (startDate1 ? 1 : 0) +
        (endDate1 ? 1 : 0);

    const handleResetFilters = () => {
        setStudentId("");
        setStartDate1("");
        setEndDate1("");
        setSearchTerm("");
        setpg(0);
        if (addClassList.length > 0) {
            const initialClassId = userDetails.role === "TEACHER" && userDetails.classId
                ? userDetails.classId
                : addClassList[0]._id;
            setClassId(initialClassId);
            const initialSectionId = userDetails.role === "TEACHER" ? (userDetails.sectionId || "") : "";
            setSectionId(initialSectionId);
            getSectionListByClass(initialClassId);
            getStudentList({ target: { value: initialClassId } }, initialSectionId || undefined);
        }
    };

    const filteredReport = getReport.filter((row) => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return true;
        return (row.studentName || "").toLowerCase().includes(term);
    });

    const studentInitials = (name) => {
        if (!name) return "?";
        const parts = String(name).split(" ").filter(Boolean);
        if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
        return String(name).slice(0, 2).toUpperCase();
    };

    const getSectionListByClass = (selectedClassId) => {
        if (!selectedClassId) {
            setSectionList([]);
            setSectionId("");
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId: selectedClassId,
        })
            .then((res) => {
                setSectionList(Array.isArray(res) ? res : []);
            })
            .catch(() => {
                setSectionList([]);
            });
    };

    const getAddClassList = () => {
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            const list = Array.isArray(res) ? res : [];
            setAddClassList(list);
            if (list.length > 0) {
                const initialClassId = userDetails.role === "TEACHER" && userDetails.classId
                    ? userDetails.classId
                    : list[0]._id;
                setClassId(initialClassId);
                const initialSectionId = userDetails.role === "TEACHER" ? (userDetails.sectionId || "") : "";
                setSectionId(initialSectionId);
                getSectionListByClass(initialClassId);
                getStudentList({ target: { value: initialClassId } }, initialSectionId || undefined);
            }
        }).catch(() => {});
    };

    const onSubmit = () => {
        fetchReport();
    };

    const getStudentList = (event, overrideSectionId) => {
        const selectedClassId = (event && event.target) ? event.target.value : classId;
        if (!selectedClassId) return;

        const body = { classId: selectedClassId };
        const effectiveSectionId =
            overrideSectionId !== undefined
                ? overrideSectionId
                : (sectionId || userDetails.sectionId || undefined);
        if (effectiveSectionId) {
            body.sectionId = effectiveSectionId;
        }

        setClassId(selectedClassId);
        StudentService.getAllStudentById(userDetails.schooleId, body)
            .then((res) => {
                const studentDetails = res.map((s) => ({
                    _id: s._id,
                    studentName: `${s.firstName} ${s.lastName}`,
                    status: true,
                }));
                setStudentList(studentDetails);
            })
            .catch(() => {});
    };

    return (
        <Box p={{ xs: 1, sm: 2 }}>
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Attendance Reports</Typography>
                    <Typography className={classes.pageSubtitle}>
                        View student attendance summary by class, section, and date range.
                    </Typography>
                </Box>
            </Box>

            {noteOpen && (
                <Box className={classes.noteBanner}>
                    <Box className={classes.noteIconWrap}>
                        <InfoOutlinedIcon style={{ fontSize: 18 }} />
                    </Box>
                    <Box flex={1}>
                        <Typography style={{ fontWeight: 600, color: '#1f3a5f', fontSize: '0.9rem' }}>
                            Attendance summary report
                        </Typography>
                        <Typography style={{ color: '#46566b', fontSize: '0.85rem', marginTop: 2 }}>
                            Select class, optional section and student, and set a date range to view attendance. Export results to Excel when ready.
                        </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => setNoteOpen(false)}>
                        <CloseIcon style={{ fontSize: 18, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
            )}

            <Card elevation={0} className={classes.filtersCard}>
                <Box className={classes.filtersRow}>
                    <span className={classes.filtersChip} onClick={() => setFiltersOpen((v) => !v)}>
                        <FilterListIcon style={{ fontSize: 18 }} />
                        Filters
                        {activeFilterCount > 0 && <span className={classes.countBadge}>{activeFilterCount}</span>}
                        {filtersOpen ? <ExpandMoreIcon style={{ fontSize: 18 }} /> : <ChevronRightIcon style={{ fontSize: 18 }} />}
                    </span>

                    {filtersOpen && (
                        <>
                            <Box className={classes.filterFieldWrap}>
                                <Typography className={classes.fieldLabel}>
                                    <SchoolIcon style={{ fontSize: 16 }} /> Class
                                </Typography>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <Select
                                        displayEmpty
                                        name="classId"
                                        value={classId}
                                        onChange={(e) => {
                                            const selected = e.target.value;
                                            setClassId(selected);
                                            setSectionId("");
                                            getSectionListByClass(selected);
                                            getStudentList(e, undefined);
                                        }}
                                    >
                                        <MenuItem value=""><em>Select Class</em></MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box className={classes.filterFieldWrap}>
                                <Typography className={classes.fieldLabel}>
                                    <SchoolIcon style={{ fontSize: 16 }} /> Section (Optional)
                                </Typography>
                                <FormControl variant="outlined" size="small" fullWidth disabled={!classId || sectionList.length === 0}>
                                    <Select
                                        displayEmpty
                                        value={sectionId}
                                        onChange={(e) => {
                                            const newSectionId = e.target.value;
                                            setSectionId(newSectionId);
                                            if (classId) {
                                                getStudentList({ target: { value: classId } }, newSectionId || undefined);
                                            }
                                        }}
                                    >
                                        <MenuItem value=""><em>All Sections</em></MenuItem>
                                        {sectionList.map(({ _id, sectionName }) => (
                                            <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box className={classes.filterFieldWrap}>
                                <Typography className={classes.fieldLabel}>
                                    <PersonIcon style={{ fontSize: 16 }} /> Student
                                </Typography>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <Select
                                        displayEmpty
                                        name="studentId"
                                        value={studentId}
                                        onChange={(e) => setStudentId(e.target.value)}
                                    >
                                        <MenuItem value=""><em>All Students</em></MenuItem>
                                        {studentList.map(({ index, _id, studentName }) => (
                                            <MenuItem key={index} value={_id}>{studentName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box className={classes.filterFieldWrap}>
                                <Typography className={classes.fieldLabel}>Start Date</Typography>
                                <SchoolDatePicker
                                    value={startDate1}
                                    onChange={(iso) => setStartDate1(iso)}
                                />
                            </Box>
                            <Box className={classes.filterFieldWrap}>
                                <Typography className={classes.fieldLabel}>End Date</Typography>
                                <SchoolDatePicker
                                    value={endDate1}
                                    onChange={(iso) => setEndDate1(iso)}
                                />
                            </Box>
                            <Box className={classes.filterActionsWrap}>
                                <Typography className={classes.fieldLabel} style={{ visibility: 'hidden' }}>Reset</Typography>
                                <Button className={classes.resetBtn} variant="outlined" onClick={handleResetFilters}>
                                    Reset
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>
            </Card>

            <Card elevation={0} className={classes.tableCard}>
                <Box className={classes.toolbar}>
                    <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
                        {filteredReport.length} Record{filteredReport.length !== 1 ? 's' : ''}
                    </Typography>
                    <Box display="flex" alignItems="center" gridGap={10}>
                        <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Search students..."
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setpg(0);
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Tooltip title="Refresh">
                            <IconButton className={classes.iconBtnOutlined} size="small" onClick={onSubmit}>
                                <RefreshIcon style={{ fontSize: 20, color: '#46566b' }} />
                            </IconButton>
                        </Tooltip>
                        <ExportExcel excelData={result} fileName={'Student Activity'} />
                    </Box>
                </Box>

                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.headCell}>Student Name</TableCell>
                                <TableCell className={classes.headCell} align="center">Working Days</TableCell>
                                <TableCell className={classes.headCell} align="center">Days Present</TableCell>
                                <TableCell className={classes.headCell} align="center">Days Absent</TableCell>
                                <TableCell className={classes.headCell} align="center">Late Coming</TableCell>
                                <TableCell className={classes.headCell} align="center">Early Going</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredReport.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center" style={{ padding: 32, color: '#7a8aa0' }}>
                                        No attendance records found.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                filteredReport.slice(pg * rpg, pg * rpg + rpg).map((report, idx) => (
                                    <TableRow key={report._id || `${report.studentName}-${idx}`} hover>
                                        <TableCell>
                                            <Box display="flex" alignItems="center" gridGap={8}>
                                                <Avatar className={classes.studentAvatar}>
                                                    {studentInitials(report.studentName)}
                                                </Avatar>
                                                <Typography style={{ fontWeight: 600, color: '#0f2d4d', fontSize: '0.875rem' }}>
                                                    {report.studentName}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center">{report.count}</TableCell>
                                        <TableCell align="center">
                                            <span className={classes.statPill} style={{ backgroundColor: '#e8f5e9', color: '#2e7d32' }}>
                                                {report.present}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center">
                                            <span className={classes.statPill} style={{ backgroundColor: '#ffebee', color: '#c62828' }}>
                                                {report.absent}
                                            </span>
                                        </TableCell>
                                        <TableCell align="center">{report.lateComing || 0}</TableCell>
                                        <TableCell align="center">{report.earlyGoing || 0}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    rowsPerPageOptions={[1000, 10000, 100000]}
                    count={filteredReport.length}
                    page={pg}
                    onPageChange={handleChangePage}
                    rowsPerPage={rpg}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>
        </Box>
    );
}
